<template>
	<div class="simple_gallary_screen" id="gallery">
		<div class="simple_gallary_carousel_box">
			<carousel v-if="screenWidth < 520"
				:per-page="1"
				:mouse-drag="true"
				:loop="true"
				:navigationEnabled="true"
				:navigationNextLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
				:navigationPrevLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
			>

				<slide :key="idx" v-for="idx in items" style="padding: 0.5em;">
					<img style="width: 95%; height: auto; object-fit: cover;" src="../assets/img/c016135271483995e0344ec184bd6262.jpeg" alt="">
				</slide>
			</carousel>
			<carousel v-if="screenWidth > 520"
				:per-page="1"
				:mouse-drag="true"
				:loop="true"
				:navigationEnabled="true"
				:navigationNextLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 40C1 31.2193 8.7463 23.6256 20 20C8.7463 16.3744 1 8.7807 1 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
				:navigationPrevLabel="`<svg width='21' height='40' viewBox='0 0 21 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M20 40C20 31.2193 12.2537 23.6256 0.999999 20C12.2537 16.3744 20 8.7807 20 -2.22278e-06' stroke='#A6CBD3' style='stroke:#A6CBD3;stroke-opacity:1;' stroke-width='2' stroke-linejoin='bevel'/></svg>`"
			>
				<slide :key="idx" v-for="(src, idx) in items">
					<div class="simple_gallary_carousel_item_box">
						<img style="width: 80%;" :src="src" alt="">
					</div>
				</slide>
			</carousel>
		</div>
	</div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

export default {
	props: {
		// items: {
		// 	type: Array,
		// 	default: [],
		// }
	},
	name: "SimpleGalleryComponent",
	components: {
		Carousel,
		Slide,
	},
	data() {
		return {
			screenScrolled: 0,
			screenWidth: 0,
			screenHeight: 0,
			items: [
				require('../assets/img/carousel/барбекю.jpg'),
				require('../assets/img/carousel/бассейн1.jpg'),
				require('../assets/img/carousel/бассейн2.jpg'),
				require('../assets/img/carousel/бассенй.jpg'),
				require('../assets/img/carousel/беседка.jpg'),
				require('../assets/img/carousel/бэби.jpg'),
				require('../assets/img/carousel/бэби1.jpg'),
				require('../assets/img/carousel/бэби2.jpg'),
				require('../assets/img/carousel/волна.jpg'),
				require('../assets/img/carousel/волна1.jpg'),
				require('../assets/img/carousel/детский городок.jpg'),
				require('../assets/img/carousel/спорт площ1.jpg'),
				require('../assets/img/carousel/трен2.jpg'),
				require('../assets/img/carousel/тренажер.jpg'),
			],
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize)
		window.addEventListener('scroll', this.handleScroll)
		this.handleResize()
		this.handleScroll()
	},
	computed: {
		// screenScrolled() {
		// 	return window.scrollY
		// }
	},
	methods: {
		handleScroll() {
			this.screenScrolled = window.scrollY;
		},
		handleResize() {
			this.screenWidth = window.innerWidth;
			this.screenHeight = window.innerHeight;
		}
	},
}
</script>

<style>
.VueCarousel-dot, .VueCarousel-dot:active {
	background-color: transparent !important;
	border: 1px solid #A6CBD3 !important;
	padding: 0 !important;
	margin: 0.5em;
}
.VueCarousel-dot.VueCarousel-dot--active {
	background-color: #A6CBD3 !important;
}
.simple_gallary_carousel_box {
	width: 80%;
	margin: 0 auto;
	/*padding: 0 10%;*/
	padding: 5em 0em;
	/*display: flex;*/
	/*flex-direction: column;*/
	/*flex-wrap: nowrap;*/
	/*justify-content: center;*/
	/*align-items: center;*/
	/*align-content: center;*/
}
.simple_gallary_screen {
	padding: 0em;
	background: #161616FF;
	width: 100%;

	text-align: center;
	position: relative;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: center;
}
.simple_gallary_carousel_box img  {
	object-fit: cover;
	width: 100%;
	height: 100%;
	max-height: 500px;
	border-radius: 10px 10px 10px 10px;
}

.simple_gallary_carousel_item_box {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	align-items: flex-start;
	justify-content: center;
}
@media (max-width: 575px) {
	.simple_gallary_carousel_box {
		width: 100%;
	}
	.VueCarousel-navigation-next,
	.VueCarousel-navigation-prev {
		height: 1.4em;
		padding: 0 !important;
		margin: 0 !important;
	}
	.VueCarousel-navigation-next {
		transform: translateY(-100%) translateX(100%);
		right: 0.95em !important;
	}
	.VueCarousel-navigation-prev {
		transform: translateY(-100%) translateX(-100%);
		left: 0.95em !important;
	}
	.VueCarousel-navigation-next svg,
	.VueCarousel-navigation-prev svg {
		height: 100%;
		width: auto;

	}
}
</style>